import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import "./i18n.js";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
